// removed by extract-text-webpack-plugin
module.exports = {"error":"error__2OMFq","error_message":"error_message__2bQSz","error_retry":"error_retry__ECnHa"};


//////////////////
// WEBPACK FOOTER
// ./components/error/style.scss
// module id = yR6k
// module chunks = 13